import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../../utils/axiosInstance";

export const getSpotGoldProductDetailsApi = createAsyncThunk(
  "spotGoldProductDetails",
  async (id) => {
    // console.log("ID+++++++++++++++++",id)
    const response = await axiosInstance.get(`/category/product/${id}`);
    return response.data;
  }
);

const spotGoldProductDetailsSlice = createSlice({
  name: "spotGoldProductDetails",
  initialState: {
    spotGoldProductDetails: [],
    errors: [],
    status: "idle",
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getSpotGoldProductDetailsApi.pending, (state) => {
        state.status = "loading";
      })
      .addCase(getSpotGoldProductDetailsApi.fulfilled, (state, action) => {
        state.spotGoldProductDetails = action.payload;
        state.status = "idle";
      })
      .addCase(getSpotGoldProductDetailsApi.rejected, (state, action) => {
        state.errors.push(action.error.message);
        state.status = "idle";
      });
  },
});

export default spotGoldProductDetailsSlice.reducer;
